import React, { useCallback } from 'react'
import { modal, ModalParams } from '@codeleap/modals'
import { APIClient } from '@/services'
import { LearnCard } from '..'
import { SearchGlobal } from '@/components'

export const LearnSearch = ({
  toggle,
  onBack,
}: ModalParams & {
  onBack?: () => void
}) => {
  const [search, setSearch] = React.useState('')
  const { listProps } = APIClient.Learn.useLearnSearch(search)

  const renderModuleItem = React.useCallback(({ item }) => {
    if (!item?.id || !item?.title) {
      return null
    }

    return <LearnCard item={item} onPress={toggle} />
  }, [])

  const handleBack = useCallback(() => {
    if (onBack) {
      onBack()
    } else {
      toggle()
    }
  }, [])

  return (
    <SearchGlobal
      onBack={handleBack}
      listProps={listProps}
      renderCard={renderModuleItem}
      onSearch={setSearch}
      search={search}
    />
  )
}

export const LearnSearchModal = modal()
  .content(LearnSearch)
  .props({ variants: ['centered'], showClose: false })
